import { render, staticRenderFns } from "./FormsContainer.vue?vue&type=template&id=79a4c92a&"
import script from "./FormsContainer.vue?vue&type=script&lang=js&"
export * from "./FormsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports